<p-toast />
<p-confirmDialog />

<div class="version-container">
    <div class="version-wrapper">
        <div class="version-content">
            <div class="grid py-5">
                <div class="col-12">
                    <div class="flex justify-content-between align-items-center mb-4">
                        <div>
                            <h2>Invoice Generation from JSON Payloads</h2>
                            <p class="text-sm text-color-secondary mt-2">
                                Current Location: <strong>{{ currentLocationId || 'Not set' }}</strong>
                            </p>
                        </div>
                        <button pButton
                                icon="pi pi-refresh"
                                label="Refresh"
                                class="p-button-outlined"
                                (click)="refreshFiles()"
                                [disabled]="loading"></button>
                    </div>

                    <p class="mb-4">
                        Select a JSON payload file to create an invoice. Files are loaded from
                        <code>local-files/invoice-payloads/</code>
                    </p>

                    <p-table
                        [value]="filteredFiles"
                        [tableStyle]="{ 'min-width': '80rem' }"
                        [loading]="loading"
                        [paginator]="true"
                        [rows]="25"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [globalFilterFields]="['fileName', 'locationNumber', 'suite', 'account', 'relativePath']"
                        #dt>

                        <ng-template pTemplate="caption">
                            <div class="flex">
                                <span class="p-input-icon-left ml-auto">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                           (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                           placeholder="Search files..." />
                                </span>
                            </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="fileName">
                                    File Name <p-sortIcon field="fileName" />
                                </th>
                                <th pSortableColumn="locationNumber">
                                    Location <p-sortIcon field="locationNumber" />
                                </th>
                                <th pSortableColumn="suite">
                                    Suite <p-sortIcon field="suite" />
                                </th>
                                <th pSortableColumn="account">
                                    Account <p-sortIcon field="account" />
                                </th>
                                <th pSortableColumn="timestamp">
                                    Timestamp <p-sortIcon field="timestamp" />
                                </th>
                                <th pSortableColumn="fileSize">
                                    Size <p-sortIcon field="fileSize" />
                                </th>
                                <th pSortableColumn="modifiedDate">
                                    Modified <p-sortIcon field="modifiedDate" />
                                </th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-file>
                            <tr>
                                <td>
                                    <span [pTooltip]="file.relativePath">
                                        {{ file.fileName }}
                                    </span>
                                </td>
                                <td>{{ file.locationNumber }}</td>
                                <td>{{ file.suite }}</td>
                                <td>{{ file.account }}</td>
                                <td>{{ formatTimestamp(file.timestamp) }}</td>
                                <td>{{ formatFileSize(file.fileSize) }}</td>
                                <td>{{ formatDate(file.modifiedDate) }}</td>
                                <td>
                                    <button pButton
                                            icon="pi pi-file-plus"
                                            label="Create Invoice"
                                            class="p-button-sm p-button-success"
                                            (click)="confirmCreateInvoice(file)"
                                            [disabled]="creating"
                                            [loading]="creating && selectedFile === file"></button>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8" class="text-center">
                                    <div class="py-5">
                                        <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
                                        <p class="mt-3"><b>No invoice payload files found for your current location.</b></p>
                                        <p class="text-sm text-color-secondary">
                                            Place JSON files in <code>local-files/invoice-payloads/</code>
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>
